import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${theme.spacing['2xl']};
  padding-bottom: ${theme.spacing['2xl']};
`;
